import { Trans } from '@lingui/macro';

export const SIM_STATUS_LOCKED = 'Locked';
export const SIM_STATUS_UNLOCKED = 'Unlocked';
export const SIM_STATUS_LOCKED_UPPER = SIM_STATUS_LOCKED.toLocaleUpperCase();
export const SIM_STATUS_UNLOCKED_UPPER =
  SIM_STATUS_UNLOCKED.toLocaleUpperCase();
export const NONE = 'none';

export const OUTCOME_RETURN = 'RETURN_DEVICE';
export const OUTCOME_UPGRADE = 'UPGRADE';
export const OUTCOME_VOUCHER = 'VOUCHER';

export const networkStatus = [
  SIM_STATUS_LOCKED,
  SIM_STATUS_UNLOCKED,
  SIM_STATUS_LOCKED_UPPER,
  SIM_STATUS_UNLOCKED_UPPER,
  NONE,
];

export const simStatusLabels = () => ({
  [SIM_STATUS_LOCKED]: <Trans id='recycle.network.locked'>Locked</Trans>,
  [SIM_STATUS_UNLOCKED]: <Trans id='recycle.network.unlocked'>Unlocked</Trans>,
  [SIM_STATUS_LOCKED_UPPER]: <Trans id='recycle.network.locked'>Locked</Trans>,
  [SIM_STATUS_UNLOCKED_UPPER]: (
    <Trans id='recycle.network.unlocked'>Unlocked</Trans>
  ),
  [NONE]: <Trans id='recycle.network.none'>None</Trans>,
});

export const REPORTS_STATUS = {
  ALL: 'ALL',
  CREATED: 'CREATED',
  ORDER_SUCCESSFUL: 'ORDER_SUCCESSFUL',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
};
export const TRADECART_ID_REGEX = /^[a-z]{2}-[a-z]{2}-20[0-9]{2}-T[0-9]{7}$/i;
export const RECYCLE_STATUS = {
  SWAP: 'SWAP',
  NO_SWAP: 'NO_SWAP',
  TRADE_IN: 'TRADE_IN',
};
